<template>
  <div>
    <el-drawer
      :destroy-on-close="true"
      :append-to-body="true"
      title="Ayarlar"
      :visible.sync="settings"
      :with-header="false"
    >
      <div class="row" style="padding: 50px">
        <div class="col-md-12">
          <label for="">{{ $t("module.show_time") }}</label>
          <el-slider
            v-model="speed"
            :format-tooltip="formatTooltip"
            :step="1"
            :min="5"
            :max="15"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12">
          <label for="">{{ $t("module.level") }}</label>
          <el-slider
            v-model="level"
            :step="1"
            :min="1"
            :max="levels.length"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">{{
            $t("module.autolevel")
          }}</label>
          <el-switch
            style="margin-top: 8px"
            v-model="autoLevel"
            :active-text="$t('module.yes')"
            :active-value="1"
            :inactive-value="0"
            :inactive-text="$t('module.no')"
          >
          </el-switch>
        </div>
      </div>
    </el-drawer>
    <div id="goz_esnetme">
      <paused
        v-if="pause"
        @click="
          $root.$emit('pause', !pause);
          pause = false;
        "
      ></paused>
      <a
        href="javascript:;"
        @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        "
        class="pause"
      >
        <i
          :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"
        ></i>
      </a>
      <a
        href="javascript:;"
        v-if="config == null || config == undefined"
        @click.stop="settings = true"
        class="settings"
      >
        <i class="el-icon-setting"></i>
      </a>
      <div
        v-if="(currentCounter != 0 && startCounter == 0) || flash"
        v-for="(letter, index) in options"
        class="dark-inverted"
        style="
          font-size: 20px;
          border-radius: 5px;
          cursor: pointer;
          display: inline-block;
          text-align: center;
          margin: 3px;
        "
        @click="pick(index)"
        :style="{
          background: getColor(letter),
          width: wrapper.width / 16 - 6 + 'px',
          color:
            getColor(letter) == 'rgb(28, 68, 156) !important' ? 'white' : '',
        }"
      >
        {{ letter.letter }}
      </div>
      <div
        class="dark-inverted"
        style="
          font-size: 22px;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
        "
        v-if="startCounter > 0"
      >
        <h1 style="font-size: 55px">{{ startCounter }}</h1>
        <span>{{ $t("module.farkliolan.description") }}</span>
      </div>
    </div>
    <div
      v-if="startCounter == 0"
      :style="{ width: wrapper.width + 'px' }"
      style="margin: 0 auto; border-radius: 0px"
    >
      <div class="progress" style="border-radius: 0px; height: 5px">
        <div
          class="progress-bar"
          style="border-radius: 0px"
          :style="{
            width: (currentCounter / speed) * 100 + '%',
            height: '40px',
          }"
        ></div>
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: row;
        "
        v-if="pause == false"
      >
        <div
          style="font-size: 32px; font-weight: bold"
          class="dark-inverted true-count"
        >
          {{ this.options.filter((k) => k.letter == currentLetter).length }}/{{
            this.options.filter(
              (k) => k.letter == currentLetter && k.picked == true
            ).length
          }}
        </div>
        <div style="display: flex; flex-direction: row">
          <span
            class="num"
            style="display: flex; align-items: center; justify-content: center"
          >
            <div
              style="
                position: relative;
                z-index: 9999;
                background-color: red;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                color: white;
                align-items: center;
                justify-content: center;
                display: flex;
                font-size: 22px;
              "
            >
              <i class="fas fa-times"></i>
            </div>
            <span
              style="
                font-size: 35px;
                font-weight: bold;
                color: white;
                background: red;
                height: 40px;
                padding-left: 20px;
                margin-left: -20px;
                z-index: 1;
                position: relative;
                line-height: 45px;
                padding-right: 10px;
              "
              >{{ totalFalse }}</span
            >
          </span>
          <span
            class="num"
            style="display: flex; align-items: center; justify-content: center"
          >
            <span
              style="
                font-size: 35px;
                font-weight: bold;
                color: white;
                background: rgb(28, 68, 156);
                height: 40px;
                padding-right: 20px;
                margin-right: -20px;
                z-index: 0;
                position: relative;
                line-height: 45px;
                padding-left: 10px;
              "
              >{{ totalTrue }}</span
            >
          </span>
          <svg
            height="40px"
            viewBox="0 0 512 512"
            width="40px"
            xmlns="http://www.w3.org/2000/svg"
            style="position: relative; z-index: 2"
          >
            <path
              d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 0"
              fill="rgb(28, 68, 156)"
            />
            <path
              d="m385.75 201.75-138.667969 138.664062c-4.160156 4.160157-9.621093 6.253907-15.082031 6.253907s-10.921875-2.09375-15.082031-6.253907l-69.332031-69.332031c-8.34375-8.339843-8.34375-21.824219 0-30.164062 8.339843-8.34375 21.820312-8.34375 30.164062 0l54.25 54.25 123.585938-123.582031c8.339843-8.34375 21.820312-8.34375 30.164062 0 8.339844 8.339843 8.339844 21.820312 0 30.164062zm0 0"
              fill="#fafafa"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  props: ["config"],
  name: "GozEsnekligi",
  data() {
    return {
      pause: false,
      answerStack: [],
      speed: 15,
      words:
        "Lorem Ipsum, dizgi ve baskı endüstrisinde kullanılan mıgır metinlerdir. Lorem Ipsum, adı bilinmeyen bir matbaacının bir hurufat numune kitabı oluşturmak üzere bir yazı galerisini alarak karıştırdığı 1500'lerden beri endüstri standardı sahte metinler olarak kullanılmıştır. Beşyüz yıl boyunca varlığını sürdürmekle kalmamış, aynı zamanda pek değişmeden elektronik dizgiye de sıçramıştır. 1960'larda Lorem Ipsum pasajları da içeren Letraset yapraklarının yayınlanması ile ve yakın zamanda Aldus PageMaker gibi Lorem Ipsum sürümleri içeren masaüstü yayıncılık yazılımları ile popüler olmuştur.".split(
          " "
        ),
      top: 0,
      left: 0,
      word: null,
      rotate: 0,
      currentCounter: 15,
      startCounter: 5,
      level: 1,
      levels: [
        {
          min: 3,
          max: 4,
          row: 6,
          speed: 15,
        },
        {
          min: 4,
          max: 5,
          row: 6,
          speed: 12,
        },
        {
          min: 4,
          max: 5,
          row: 7,
          speed: 10,
        },
        {
          min: 5,
          max: 6,
          row: 7,
          speed: 10,
        },
        {
          min: 6,
          max: 7,
          row: 8,
          speed: 8,
        },
        {
          min: 7,
          max: 8,
          row: 10,
          speed: 8,
        },
        {
          min: 7,
          max: 9,
          row: 12,
          speed: 6,
        },
        {
          min: 8,
          max: 10,
          row: 12,
          speed: 5,
        },
      ],
      options: [],
      letters: [
        {
          letter1: "3",
          letter2: "5",
        },
        {
          letter1: "G",
          letter2: "6",
        },
        {
          letter1: "M",
          letter2: "N",
        },
        {
          letter1: "F",
          letter2: "H",
        },
        {
          letter1: "C",
          letter2: "Ç",
        },
        {
          letter1: "I",
          letter2: "L",
        },
        {
          letter1: "O",
          letter2: "C",
        },
        {
          letter1: "E",
          letter2: "F",
        },
        {
          letter1: "V",
          letter2: "U",
        },
        {
          letter1: "S",
          letter2: "Ş",
        },
        {
          letter1: "d",
          letter2: "b",
        },
        {
          letter1: "h",
          letter2: "b",
        },
        {
          letter1: "v",
          letter2: "y",
        },
        {
          letter1: "u",
          letter2: "ü",
        },
        {
          letter1: "i",
          letter2: "ı",
        },
        {
          letter1: "f",
          letter2: "t",
        },
        {
          letter1: "w",
          letter2: "v",
        },
        {
          letter1: "q",
          letter2: "p",
        },
        {
          letter1: "r",
          letter2: "n",
        },
        {
          letter1: "a",
          letter2: "o",
        },
        {
          letter1: "6",
          letter2: "9",
        },
        {
          letter1: "8",
          letter2: "3",
        },
      ],
      currentLetter: null,
      lodash: _,
      wrapper: {
        width: 0,
        height: 0,
      },
      positions: [],
      totalTrue: 0,
      totalFalse: 0,
      counts: [],
      flash: false,
      settings: false,
      autoLevel: 0,
      levelLock: false,
      totalClick: 0,
      totalItem: 0,
      totalTrueItem: 0,
      totalPickedTrueItem: 0,
      lastPickTime: new Date().getTime(),
      firstReactions: [],
    };
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
    this.start();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    formatTooltip(val) {
      return val + " saniye";
    },
    pick(index) {
      this.totalClick += 1;
      if (this.flash) return;
      if (this.options[index].letter == this.currentLetter) {
        this.totalPickedTrueItem += 1;
        if (
          !this.options.some(
            (k) => k.picked == true && k.letter == this.currentLetter
          )
        ) {
          this.firstReactions.push(new Date().getTime() - this.lastPickTime);
        }
      }
      this.options[index].picked = true;
      if (
        !this.options.some(
          (k) => k.picked == false && k.letter == this.currentLetter
        )
      ) {
        clearInterval(this.interval);
        clearInterval(this.startInterval);
        this.end();
      }
    },
    getColor(letter) {
      if (
        this.flash == true &&
        letter.letter == this.currentLetter &&
        letter.picked == false
      ) {
        return "white !important";
      }
      if (
        this.flash == true &&
        letter.letter == this.currentLetter &&
        letter.picked == true
      ) {
        return "rgb(28, 68, 156) !important";
      }
      if (
        this.flash == false &&
        letter.letter == this.currentLetter &&
        letter.picked == true
      ) {
        return "rgb(28, 68, 156) !important";
      }
      if (
        this.flash == false &&
        letter.letter != this.currentLetter &&
        letter.picked == true
      ) {
        return "red !important";
      }
      if (
        this.flash == true &&
        letter.letter != this.currentLetter &&
        letter.picked == true
      ) {
        return "red !important";
      }
    },
    end() {
      this.flash = true;
      if (
        this.options.filter(
          (k) => k.letter == this.currentLetter && k.picked == true
        ).length ==
        this.options.filter((k) => k.letter == this.currentLetter).length
      ) {
        this.totalTrue += 1;
      } else {
        this.totalFalse += 1;
      }
      setTimeout(() => {
        this.start();
      }, 3000);
    },
    start() {
      this.flash = false;
      this.positions = [];
      this.options = [];
      this.startCounter = 3;
      this.currentCounter = this.speed;
      var letters = this.letters[_.random(0, this.letters.length - 1)];

      this.currentLetter = letters.letter1;
      var x = _.random(
        this.levels[this.level - 1].min,
        this.levels[this.level - 1].max
      );
      for (let index = 0; index < x; index++) {
        this.options.push({ letter: letters.letter1, picked: false });
      }

      for (
        let index = 0;
        index < this.levels[this.level - 1].row * 16 - x;
        index++
      ) {
        this.options.push({ letter: letters.letter2, picked: false });
      }

      this.options = _.shuffle(this.options);

      this.totalTrueItem += this.options.filter(
        (k) => k.letter == this.currentLetter
      ).length;

      this.totalItem += this.options.length;

      this.startInterval = setInterval(() => {
        if (this.pause) return;
        this.startCounter -= 1;
        if (this.startCounter == 0) {
          clearInterval(this.startInterval);
          this.lastPickTime = new Date().getTime();
          this.interval = setInterval(() => {
            if (this.pause) return;
            this.currentCounter -= 1;
            if (this.currentCounter == 0) {
              clearInterval(this.interval);
              this.end();
            }
          }, 1000);
        }
      }, 1000);
    },
  },
  computed: {
    currentSpeed() {
      return 1000;
    },
  },
  watch: {
    totalPickedTrueItem: function (a, b) {
      if (this.totalPickedTrueItem == 0 || a == b) return;

      setTimeout(() => {
        $(".true-count").addClass("animate__animated animate__rubberBand");
        setTimeout(() => {
          $(".true-count").removeClass("animate__animated animate__rubberBand");
        }, 500);
      }, 100);
    },
    speed: function () {
      if (this.levelLock) return;
      clearInterval(this.interval);
      clearInterval(this.startInterval);
      this.start();
    },
    level: function () {
      if (this.levelLock) return;
      clearInterval(this.interval);
      clearInterval(this.startInterval);
      this.start();
    },
    totalTrue: function () {
      this.answerStack.push(true);
      if (this.autoLevel == 0) return;
    },
    totalFalse: function () {
      this.answerStack.push(false);
    },
    answerStack: {
      deep: true,
      handler: function () {
        if (this.answerStack.filter((k) => k == true).length == 2) {
          this.answerStack = this.answerStack.filter((k) => k == false);
          this.level = Math.min(
            this.level + 1,
            this.config && this.config.max_level
              ? this.config.max_level
              : this.levels.length
          );
          this.speed = this.levels[this.level - 1].speed;
          this.levelLock = true;

          setTimeout(() => {
            this.levelLock = false;
          }, 500);
        }

        if (this.answerStack.filter((k) => k == false).length == 2) {
          this.answerStack = this.answerStack.filter((k) => k == true);
          this.level = Math.max(this.level - 1, 1);
          this.speed = this.levels[this.level - 1].speed;
          this.levelLock = true;

          setTimeout(() => {
            this.levelLock = false;
          }, 500);
        }
      },
    },
  },
  created() {
    if (this.$i18n.locale == "ru") {
      this.letters = [
        {
          letter1: "Е",
          letter2: "Ё",
        },
        {
          letter1: "Й",
          letter2: "К",
        },
        {
          letter1: "Ц",
          letter2: "Ч",
        },
        {
          letter1: "Б",
          letter2: "В",
        },
        {
          letter1: "Д",
          letter2: "Л",
        },
        {
          letter1: "6",
          letter2: "9",
        },
        {
          letter1: "3",
          letter2: "Е",
        },
      ];
    }
    if (this.config != null && this.config != undefined) {
      if (this.config.speed) this.speed = this.config.speed;
      if (this.config.level) this.level = this.config.level;
      if (this.config.autoLevel) this.autoLevel = this.config.auto_level;
    }
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  height: 500px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/FarkliOlan.vue